<template>
    <div class="tags-view-container">
         <scroll-pane class="tags-view-wrapper" ref="scrollPane">
             <router-link ref="tag"  :class="isActive(tag)?'active':''" class="tags-view-item"  :to="filterParams(tag)"  @contextmenu.prevent.native="openMenu(tag,$event)" v-for="tag in Array.from(visitedViews)" :key="tag.path" >
               {{tag.title}}
                 <span v-if="tag.title != '首页'"  class="el-icon-close" @click.prevent.stop='closeSelectedTag(tag)'></span>
             </router-link>
         </scroll-pane>
      <ul class='contextmenu' v-show="visible" :style="{left:left+'px',top:top+'px'}">
        <li @click="closeSelectedTag(selectedTag)">关闭</li>
        <li @click="closeOthersTags">关闭其他</li>
        <li @click="closeAllTags">关闭所有</li>
      </ul>
    </div>
</template>

<script>
//注意文件路径
 import ScrollPane from '@/components/common/tagsView/scrollPane'

   export default {
     name: "tagsView",
     components: { ScrollPane },
    data(){
         return{
           visible: false,
           top: 0,
           left: 0,
           selectedTag: {}
         }
    },
     computed:{
         visitedViews(){
        //    console.log('tabView')
        //    console.log(this.$store.state.tagsView)
           // console.log(this.$store.state)
           return this.$store.state.tagsView.visitedViews
         }
     },
     watch:{
        $route(){
          this.addViewTags()
          this.moveToCurrentTag()
        },
       visible(value) {
         if (value) {
           document.body.addEventListener('click', this.closeMenu)
         } else {
           document.body.removeEventListener('click', this.closeMenu)
         }
       }
     },
     mounted() {
       this.addViewTags()
     },
     methods:{
         generateRoute(){
           // console.log(this.$route.name)
           if (this.$route.path && this.$route.meta.title) {
             return this.$route
           }
           return false
         },
       isActive(route) {
         return route.path === this.$route.path
       },
       addViewTags() {
         const route = this.generateRoute()
         // console.log(route)
         if (!route) {
           return false
         }
         this.$store.dispatch('addVisitedViews', route)
       },
       moveToCurrentTag() {
         const tags = this.$refs.tag
         this.$nextTick(() => {
           for (const tag of tags) {
             if (tag.to.path === this.$route.path) {
               this.$refs.scrollPane.moveToTarget(tag.$el)
               break
             }
           }
         })
       },
       closeSelectedTag(view) {
           console.info(view)
         this.$store.dispatch('delVisitedViews', view).then((views) => {
           if (this.isActive(view)) {
             const latestView = views.slice(-1)[0]
             if (latestView) {
               this.$router.push(latestView)
             } else {
               this.$router.push('/')
             }
           }
         })
       },
       closeOthersTags() {
         this.$router.push(this.selectedTag)
         this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
           this.moveToCurrentTag()
         })
       },
       closeAllTags() {
         this.$store.dispatch('delAllViews')
         this.$router.push('/')
       },
       openMenu(tag, e) {
         this.visible = true
         this.selectedTag = tag
         const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
         this.left = e.clientX - offsetLeft + 15 // 15: margin right
         this.top = e.clientY
       },
       closeMenu() {
         this.visible = false
       },
       filterParams(tag) {
         let query = {}
         for(let k in tag.query) {
           if(k != '_redirect') {
             query[k] = tag.query[k]
           }
         }
         let newTag = {
           fullPath: tag.fullPath,
           path: tag.path,
           query: query
         }
         return newTag
       }
     }
   }
</script>

<style scoped>
   .tags-view-wrapper {
     background: #fff;
     height: 54px;
     border-bottom: 1px solid #d8dce5;
     box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
   }
   .tags-view-item {
       display: inline-block;
       position: relative;
       height: 30px;
       line-height: 30px;
       border: 1px solid #d8dce5;
       color: #495060;
       background: #fff;
       padding: 0 8px;
       font-size: 12px;
       margin-left: 5px;
       margin-top: 4px;
   }
   .tags-view-item:first-of-type {
         margin-left: 15px;
   }
   .tags-view-item.active{
     background-color: #42b983;
     color: #fff;
     border-color: #42b983;
   }
   .tags-view-item.active::before{
      content: '';
     background: #fff;
     display: inline-block;
     width: 8px;
     height: 8px;
     border-radius: 50%;
     position: relative;
     top: -1px;
     margin-right: 2px;
   }
   .contextmenu {
     margin: 0;
     background: #fff;
     z-index: 100;
     position: absolute;
     list-style-type: none;
     padding: 5px 0;
     border-radius: 4px;
     font-size: 12px;
     font-weight: 400;
     color: #333;
     box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
   }
 .contextmenu li{
     margin: 0;
     padding: 7px 16px;
     cursor: pointer;
 }
 .contextmenu li:hover{
   background: #eee;
 }
 .tags-view-item .el-icon-close{
   width: 16px;
   height: 16px;
   border-radius: 50%;
   text-align: center;
   transition: all .3s cubic-bezier(.645, .045, .355, 1);
   transform-origin: 100% 50%;
 }
 .el-icon-close:before{
   transform: scale(.6);
   display: inline-block;
 }
</style>



// WEBPACK FOOTER //
// src/components/common/tagsView/index.vue